import { useEffect } from "react";

const SITE = "https://yogatoyacht.com";

const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, key] = selector.match(/\[(?:name|property)="(.+)"\]/) || [];
    if (selector.includes("property=")) el.setAttribute("property", key);
    else el.setAttribute("name", key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setRobots = (content) => {
  let el = document.head.querySelector('meta[name="robots"]');
  if (content) {
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  } else if (el) {
    el.remove();
  }
};

const setJsonLd = (data) => {
  let el = document.getElementById("page-jsonld");
  if (data) {
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = "page-jsonld";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
  } else if (el) {
    el.remove();
  }
};

// Lightweight, dependency-free document head manager (React 19 safe).
export function useSeo({ title, description, path = "/", image, robots, noindex, jsonLd }) {
  useEffect(() => {
    const canonical = `${SITE}${path}`;
    if (title) {
      document.title = title;
      setMeta('meta[property="og:title"]', "property", title);
      setMeta('meta[name="twitter:title"]', "name", title);
    }
    if (description) {
      setMeta('meta[name="description"]', "name", description);
      setMeta('meta[property="og:description"]', "property", description);
      setMeta('meta[name="twitter:description"]', "name", description);
    }
    if (image) {
      setMeta('meta[property="og:image"]', "property", image);
      setMeta('meta[name="twitter:image"]', "name", image);
    }
    setMeta('meta[property="og:url"]', "property", canonical);
    setCanonical(canonical);
    setRobots(noindex ? "noindex, nofollow" : robots || null);
    setJsonLd(jsonLd || null);
    return () => setJsonLd(null);
  }, [title, description, path, image, robots, noindex, jsonLd]);
}
